(function ($) {
  function clearInputFileName() {
    const fileInputs = document.querySelectorAll('input[type="file"]');
    fileInputs.forEach((input) => {
      input.setAttribute('value', '');
    });
    $('.form__upload-info')?.remove();
  }

  /**
     * formInputFocusIn
     * @param event
     */
  function formInputFocusIn(event) {
    const $closest = $(event.target).closest('.form__col');
    const $label = $closest.find('.form__label');
    $label.addClass('form__label--focus');
    const $newsletterLabel = $closest.find('.newsletter__label');
    $newsletterLabel.addClass('newsletter__label--focus');
  }

  /**
     * formInputFocusOut
     * @param event
     */
  function formInputFocusOut(event) {
    setTimeout(() => {
      if ($(event.target).val() !== '') {
        return true;
      }

      if (document.querySelector('#ui-datepicker-div')) {
        if (document.querySelector('#ui-datepicker-div').clientWidth > 0) {
          return true;
        }
      }

      const $closest = $(event.target).closest('.form__col');
      const $label = $closest.find('.form__label');
      $label.removeClass('form__label--focus');
      const $newsletterLabel = $closest.find('.newsletter__label');
      $newsletterLabel.removeClass('newsletter__label--focus');

      return true;
    }, 300);
  }

  /**
     * formInput
     * @return void
     */
  function formInput() {
    const $field = $('.form__input:not([type="file"])');
    $field.on('click tap keyup', (event) => {
      formInputFocusIn(event);
    });
    $field.on('blur', (event) => {
      formInputFocusOut(event);
    });
  }

  /**
     * formUpload
     * @return void
     */
  function formUpload() {
    const $field = $('input[type=file]');
    const $button = $field.closest('.form__col').find('.wpcf7-form-control-wrap');
    const $noFile = '<span class="form__upload-info form__upload-info--default"><span class="form__upload-name">No file chosen</span></span>';

    $button
      .addClass('form__upload-button')
      .attr('tabindex', '0')
      .append('Choose file')
      .after($noFile)
      .on('click tap keyup', (event) => {
        if (event.keyCode === undefined) {
          $(event.target).find('input[type=file]').click();
        }
        if (event.keyCode === 13) {
          $(event.target).find('input[type=file]').click();
        }
      })
      .bind('change', (event) => {
        const $currentField = $(event.target);
        const $currentContainer = $currentField.closest('.form__col');
        const uploadName = $currentField[0].files[0]?.name;

        if (!uploadName) {
          formInputFocusOut(event);
          clearInputFileName();
          return;
        }

        formInputFocusIn(event);

        $currentContainer.find('.form__upload-info--default, .form__upload-info').remove();
        $currentContainer.find('.form__upload-button').after(`<span class="form__upload-info"><span class="form__upload-name">${uploadName}</span><span class="form__upload-remove" tabindex="0">Remove</span></span>`);

        $('.form__upload-remove').on('click tap keyup', (e) => {
          e.preventDefault();
          if (e.keyCode === undefined) {
            $currentField.val('');
            $('.form__upload-info').remove();
            $currentContainer.find('.form__upload-button').after($noFile);
          }
          if (e.keyCode === 13) {
            $currentField.val('');
            $('.form__upload-info').remove();
            $currentContainer.find('.form__upload-button').after($noFile);
          }
        });
      });
  }

  /**
     * Number regex input
     * @param str
     * @returns {boolean}
     */
  function numberRegexInput(str) {
    const regex = /^[0-9]+$/;
    if (!regex.test(str)) {
      return false;
    }
    return true;
  }

  /**
     * formInputNumber
     * @return boolean
     */
  function formInputNumber() {
    const availableKeyCodes = [8, 9, 37, 38, 39, 40, 46];
    $(document).on('keydown', '.form__input--number', (event) => {
      if (
        numberRegexInput(event.key) === false
        && availableKeyCodes.indexOf(event.keyCode) === -1
      ) {
        return false;
      }
      return true;
    });

    return true;
  }

  /**
     * formCheckboxTrigger
     * @param event
     * @return void
     */
  function formCheckboxTrigger(event) {
    const currChkbx = $(event.target).prev('input[type="checkbox"]');
    currChkbx.click();
  }

  /**
     * formCheckBox
     * @return void
     */
  function formCheckBox() {
    const $label = $('.form__input--checkbox .wpcf7-list-item-label');
    $label.attr('tabindex', 0).closest('.form__col').find('.wpcf7-form-control-wrap').addClass('form__input--checkbox-wrapper');
    $label.on('click tap keyup', (event) => {
      if (event.keyCode === undefined) {
        formCheckboxTrigger(event);
      } else if (event.keyCode === 13) {
        formCheckboxTrigger(event);
      }
      return false;
    });
  }

  /**
     * formRadioTrigger
     * @param event
     * @return void
     */
  function formRadioTrigger(event) {
    const currRadio = $(event.target).prev('input[type="radio"]');
    currRadio.prop('checked', 'checked');
  }

  /**
     * formRadio
     * @return void
     */
  function formRadio() {
    const $label = $('.form__input--radio .wpcf7-list-item-label');
    $label.attr('tabindex', 0).closest('.form__col').find('.wpcf7-form-control-wrap').addClass('form__input--radio-wrapper');
    $label.on('click tap keyup', (event) => {
      if (event.keyCode === undefined) {
        formRadioTrigger(event);
      }
      if (event.keyCode === 13) {
        formRadioTrigger(event);
      }
    });
  }

  function formSelect() {
    const $select = $('.form__input--select');
    const $wrapper = $select.closest('.form__col');
    $wrapper.find('.wpcf7-form-control-wrap').addClass('form__input--select-appearance');
  }

  /**
     * formDatepicker
     * @param event
     * @returns {boolean}
     */
  function formDatepickerTrigger(event) {
    $(event.target).attr('readonly', 'readonly');
    $(event.target).datepicker({ minDate: 0 });
    $(event.target).datepicker('show');
    return false;
  }

  function formDatepicker() {
    $(document).on('click tap keyup', '.form__input--date', (event) => {
      if (event.keyCode === undefined) {
        formDatepickerTrigger(event);
      }
      if (event.keyCode === 13) {
        formDatepickerTrigger(event);
      }
    });
  }

  /**
     * Add Aria Label
     * @param object
     * @param text
     */
  function ariaLabel(object, text) {
    object.attr('aria-label', text);
  }

  /**
     * Acceptance field
     * @return void
     */
  function formAcceptance() {
    const $acceptance = $('.wpcf7-acceptance');
    const $label = $acceptance.find('.wpcf7-list-item-label');

    $acceptance.addClass('form__input form__input--checkbox');
    $label.attr('tabindex', 0)
      .attr('role', 'checkbox')
      .on('click tap keyup', (event) => {
        if ($(event.target).is('a')) {
          return true;
        }

        if (event.keyCode === undefined) {
          formCheckboxTrigger(event);
        } else if (event.keyCode === 13) {
          formCheckboxTrigger(event);
        }
        return false;
      });

    ariaLabel($label, $label.clone().children().remove().end()
      .text()
      .replace('*', ''));
  }

  /**
     * dailyTotalsReadOnly
     * @param row
     * @param countTypesOfRooms
     * @return void
     */
  function dailyTotalsReadOnly(row, countTypesOfRooms) {
    row.find('.form__input--text').each(function (i) {
      if (i === countTypesOfRooms) {
        $(this).attr('disabled', 'disabled');
      }
    });
  }

  /**
     * roomsTotalsReadOnly
     * @param row
     * @return void
     */
  function roomsTotalsReadOnly(row) {
    row.find('.form__input--text').each(function () {
      $(this).attr('disabled', 'disabled');
    });
  }

  /**
     * formRepeatableFields
     * @return void
     */
  function formRepeatableFields() {
    /**
         * Count types of room.
         * Example: Single, Double, Suite
         */
    const roomTypesCount = 3;

    $('body').on('wpcf7-field-groups/change', '.wpcf7-field-groups', function (event) {
      const fieldGroupClass = '.wpcf7-field-group';
      const fieldGroupRemClass = '.wpcf7-field-group-remove';
      const formControlWrapClass = '.wpcf7-form-control-wrap';
      const $groupsInside = $(event.target).find(fieldGroupClass);

      $groupsInside.each(function (index) {
        $(this).find(fieldGroupRemClass).toggle(index > 0);
        const i = index + 1;

        $(this).find('[name]').each(function () {
          const $$ = $(this);
          const name = $$.attr('name');
          const $fcWrap = $$.closest(formControlWrapClass);
          const isArray = (name.indexOf('[]') > -1);
          const rawName = name.replace('[]', '');
          let newName = `${rawName.replace(/__[0-9]*/, '')}__${i}`;
          const newId = newName;

          if ($fcWrap.length && !$fcWrap.hasClass(newName)) {
            $fcWrap.removeClass(rawName).addClass(newName);
            const $closest = $fcWrap.closest('form__col');
            $closest.find('label').attr('for', newName);
          }

          newName += (isArray) ? '[]' : '';
          $$.attr('name', newName);
          $$.attr('id', newId);
          $$.closest('.form__col').find('.form__label').attr('for', newName);
        });
      });

      $(this).find('.wpcf7-field-group-count').val($groupsInside.length);
    });

    $(document).on('click', '#add-day', (event) => {
      event.preventDefault();

      const $groups = $('.wpcf7-field-groups');
      const $newGroup = $groups.data('group-model').clone(true);

      dailyTotalsReadOnly($newGroup, roomTypesCount);

      $groups.append($newGroup);
      $groups.trigger('wpcf7-field-groups/change');

      return false;
    });

    $(document).on('mouseleave', '#add-day', (event) => {
      $(event.target).blur().off('mouseleave');
    });

    $(document).on('click tap keyup', '.wpcf7-field-groups .form__input', (event) => {
      formInputFocusIn(event);
    });

    $(document).on('blur', '.wpcf7-field-groups .form__input', (event) => {
      formInputFocusOut(event);
    });

    /**
         * Row totals
         * @type {*|HTMLElement}
         */
    const $rowTotals = $('.form__row--totals');

    /**
         * Initial room row
         * @type {*|HTMLElement}
         */
    const $initialRoomRow = $('.form__row--repeater');

    /**
         * Daily total calculation
         * Sum values rooms by type in he row
         */
    $(document).on('change', '.form__row--repeater .form__input--text', function () {
      /**
             * Rooms in day
             * @type {Array}
             */
      const roomsInDay = [];

      /**
             * Rooms in type
             * @type {Array}
             */
      const roomsInType = [];

      /**
             * Total daily
             */
      let totalDaily = 0;

      /**
             * Room row object
             * @type {Element}
             */
      const $roomRow = $(this).closest('.form__row--repeater');

      /**
             * All rooms objects
             * @type {*|HTMLElement}
             */
      const $allRoomsRows = $('.form__row--repeater');

      $roomRow.find('.form__input--text').each(function (i) {
        if (i === roomTypesCount) {
          return false;
        }
        roomsInDay.push(parseInt($(this).val(), 10) || 0);

        return true;
      });

      totalDaily = roomsInDay.reduce((sum, current) => sum + current, 0);

      $roomRow.find('.form__input--text').each(function (i) {
        if (i === roomTypesCount) {
          $(this).val(totalDaily).closest('.form__col').find('.form__label')
            .addClass('form__label--focus');
        }
      });

      $allRoomsRows.each(function () {
        const $row = $(this);
        $row.find('.form__input--text').each(function (j) {
          roomsInType[j] = (roomsInType[j] || 0) + (parseInt($(this).val(), 10) || 0);
        });
      });

      $rowTotals.find('.form__input--text').each(function (i) {
        $(this).val(roomsInType[i]);
      });

      $rowTotals.find('.form__input--hidden').each(function (i) {
        $(this).val(roomsInType[i]);
      });
    });

    dailyTotalsReadOnly($initialRoomRow, roomTypesCount);
    roomsTotalsReadOnly($rowTotals);
  }

  /**
     * Scroll to first error tip
     * @param form
     * @param element
     */
  function scrollToFirstErrorTip(form, element) {
    console.log('not valid tip');
    setTimeout(() => {
      if (form.find(element).length !== -1) {
        $('body,html').animate({ scrollTop: $(element).offset().top - 200 }, 800);
        $(element).first().prev('.form__input').focus()
          .click();
      }
    }, 250);
  }

  $(document).ready(() => {
    // Prevent unexpected submission of form
    $(document).on('keydown', '.form__input', (event) => {
      if (event.keyCode === 13) {
        if ($(event.target).is('textarea')) {
          return;
        }
        if ($(event.target).is('a')) {
          return;
        }
        event.preventDefault();
      }
    });

    formInput();
    formInputNumber();
    formCheckBox();
    formRadio();
    formDatepicker();
    formUpload();
    formSelect();
    formRepeatableFields();
    formAcceptance();
  });

  $(document).ready(() => {
    const $file = $('input[type="file"]');
    const $radio = $('input[type="radio"]');

    $file.each(function () {
      ariaLabel($(this), 'Upload File');
    });

    $radio.each(function () {
      const $label = $(this).val();
      ariaLabel($(this), $label);
    });
  });

  $(window).on('load', () => {
    const $input = $('.form__input');
    $input.each(function () {
      if (!$(this).val()) {
        return;
      }
      const $closest = $(this).closest('.form__col');
      const $label = $closest.find('.form__label');
      $label.addClass('form__label--focus');
    });
  });

  // Fix focus for safari 12+
  $(document).on('change', 'select', (event) => {
    if ($(event.target).val() !== '') {
      formInputFocusIn(event);
    }
  });

  document.addEventListener('wpcf7submit', (event) => {
    if (event.detail.status === 'mail_sent') {
      clearInputFileName();
      $('.form__label').removeClass('form__label--focus');
    }
  }, false);

  document.addEventListener('wpcf7beforesubmit', (event) => {
    const $message = $('.wpcf7-response-output', $(event.target));

    if ($message.length) {
      $message.removeClass('wpcf7-custom-givex-failed wpcf7-custom-givex-ok');
    }
    $('.form__upload-wrapper').each(function () {
      const $this = $(this);
      $this.find('.wpcf7-not-valid-tip').remove();
    });
    $('.form__input--radio-wrapper').each(function () {
      const $this = $(this);
      $this.parent().find('.wpcf7-not-valid-tip').remove();
    });
  }, false);

  document.addEventListener('wpcf7mailsent', (event) => {
    if ('redirect_link' in event.detail.apiResponse) {
      $('.wpcf7-response-output', $(event.target)).attr('hidden', true);
      window.location.href = event.detail.apiResponse.redirect_link;
    }

    if (document.querySelector('.rfp-box')) {
      setTimeout(() => {
        const formRegularTemplate = document?.querySelector('.rfp-box');
        if (formRegularTemplate) {
          const formContentBlock = document.querySelector('.rfp-box__content');
          const formSuccessMessage = document.querySelector('.rfp-box__success');
          formContentBlock.classList.add('d-none');
          formSuccessMessage.classList.remove('d-none');

          formSuccessMessage.scrollIntoView({
            behavior: 'smooth',
          });
        }
      }, 100);
    }
  }, false);

  document.addEventListener('wpcf7invalid', () => {
    $('.form__input--radio-wrapper').each(function () {
      const $this = $(this);
      setTimeout(() => {
        $this.find('.wpcf7-not-valid-tip').appendTo($this.parent());
      }, 0);
    });
    $('.form__upload-wrapper').each(function () {
      const $this = $(this);
      setTimeout(() => {
        $this.find('.wpcf7-not-valid-tip').appendTo($this);
      }, 0);
    });
  }, false);

  document.addEventListener('wpcf7invalid', (event) => {
    const $currentForm = $(event.target).closest('form');
    const tipElement = '.wpcf7-not-valid-tip';
    scrollToFirstErrorTip($currentForm, tipElement);
  }, false);

  document.addEventListener('wpcf7beforesubmit', (event) => {
    $(event.target).find(':input[type="submit"]').attr('disabled', 'disabled');
  });

  document.addEventListener('wpcf7invalid', (event) => {
    $(event.target).find(':input[type="submit"]').removeAttr('disabled');
  });

  document.addEventListener('wpcf7submit', (event) => {
    $(event.target).find(':input[type="submit"]').removeAttr('disabled');
  });

  $(document).on('change', '.form__upload', (e) => {
    $(e.target).closest('.form__upload--wrapper').find('.wpcf7-not-valid-tip').remove();
  });

  document.addEventListener('DOMContentLoaded', () => {
    const cLinkToForm = document.querySelectorAll('.form-anchor');
    cLinkToForm.forEach((link) => link.addEventListener('click', (e) => {
      e.preventDefault();
      const form = document.querySelector(e.target.getAttribute('href')).querySelector('form');
      const firstEl = form.querySelector('input:not([type="hidden"]), select, textarea');
      document.body.classList.add('c-keyDown');
      document.querySelector(`[for="${firstEl.id}"]`).classList.add('form__label--focus');
      document.getElementById(firstEl.id).focus();
    }));
  });
// eslint-disable-next-line no-undef
}(jQuery));
